/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Ended_Before_StartedInputs */

const en_us2_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout was recorded as ending before it started. Check the phone's clock.`)
};

const pt_br2_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ficou registrado como encerrado antes de começar. Confira o relógio do celular.`)
};

const es_419_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento quedó registrado como terminado antes de empezar. Revisa el reloj del teléfono.`)
};

const pt_pt2_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ficou registado como terminado antes de começar. Verifica o relógio do telemóvel.`)
};

const fr_fr2_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance a été enregistrée comme terminée avant d'avoir commencé. Vérifie l'horloge du téléphone.`)
};

const de_de2_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training wurde als beendet erfasst, bevor es begann. Prüf die Uhr deines Handys.`)
};

const it_it2_workout_ended_before_started = /** @type {(inputs: Workout_Ended_Before_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento risulta terminato prima di iniziare. Controlla l'orologio del telefono.`)
};

/**
* | output |
* | --- |
* | "This workout was recorded as ending before it started. Check the phone's clock." |
*
* @param {Workout_Ended_Before_StartedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_ended_before_started = /** @type {((inputs?: Workout_Ended_Before_StartedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Ended_Before_StartedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_ended_before_started(inputs)
	if (locale === "es-419") return es_419_workout_ended_before_started(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_ended_before_started(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_ended_before_started(inputs)
	if (locale === "de-DE") return de_de2_workout_ended_before_started(inputs)
	if (locale === "it-IT") return it_it2_workout_ended_before_started(inputs)
	return en_us2_workout_ended_before_started(inputs)
});
export { workout_ended_before_started as "workout.ended_before_started" }